import { createSlice } from "@reduxjs/toolkit";
import { CandidateState, StateMap } from "../../../../../lib/constant.ts";
import { fetchWebCandidatesList } from "../api.ts";
import { webCandidatesInitialState } from "../../constants.ts";

const initialState = webCandidatesInitialState;

export const webCandidatesSlice = createSlice({
  name: "webCandidates",
  initialState,
  reducers: {
    setDefaultTab: (state, action) => {
      state.stateFilter =
        action.payload.status == StateMap.Curated
          ? ""
          : CandidateState.Interviewed;
    },
    setSourceUser: (state, action) => {
      state.sourceUser = action.payload
    },
    prevPage: (state) => {
      if (state.page > 1) state.page = state.page - 1;
    },
    nextPage: (state) => {
      if (state.metadata.next) state.page = state.page + 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setStateTab: (state, action) => {
      state.stateFilter = action.payload;
    },
    setSort: (state, action) => {
      state.sortBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebCandidatesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebCandidatesList.fulfilled, (state, action) => {
        const { results, ...metadata } = action.payload.data;
        const status = action.payload.status;
        state.metadata = metadata ?? {};

        if (results || action?.payload?.data?.count > 0) {
          if (status == StateMap.All) {
            state.list.all = results;
          } else if (status == StateMap.Interviewed) state.list.completed = results;
          else if (status == StateMap.InviteSent) state.list.invited = results;
          else if (status == StateMap.PreInvite) state.list.preInvite = results;
          else if (status == StateMap.Unqualified)
            state.list.unqualified = results;
          else if (status == StateMap.Others) state.list.misc = results;
          else if (status == StateMap.Rejected) state.list.rejected = results;
          else state.list.curated = results;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchWebCandidatesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const {
  prevPage,
  nextPage,
  setPage,
  setDefaultTab,
  setStateTab,
  setSort,
  setSourceUser
} = webCandidatesSlice.actions;

export default webCandidatesSlice.reducer;
